import "@amzn/awsui-global-styles/polaris.css";
import React from "react";
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";

import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query'
import {toast, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {PageNotFound} from "src/components/errors/page-not-found";
import WIMOutput from "src/components/wim-output/index";
import ServiceHomepage from "src/components/home";
import DomainTracker from "src/components/domain-tracker"
import '@amzn/awsui-components-react/index.css';
import {Authentication} from "src/components/Authentication";
import ExecutionAttemptsPage from "src/components/execution-attempts";
import {AppRouteParams, AppRoutes} from "src/components/common/router-common";
import ExecutionDetailPage from "src/components/execution-detail";
import VirtualPipeline from "src/components/virtual-pipeline";
import {ExecutionSummary} from "src/components/execution-summary";
import {EsQueryConverter} from "src/components/filters/es-query-converter";
import {ExecutionSummaryRedirectPage} from "src/components/execution-summary/redirect";
import VirtualPipelineVisualization from "src/components/virtual-pipeline/virtual-pipeline-visualization";
import VirtualPipelineInstance from "src/components/virtual-pipeline/virtual-pipeline-instance";
import {ReleaseNotes} from "src/components/release-notes";
import StartWorkflowInstance from "src/components/start-workflow-instance";
import RestartWorkflowInstance from "src/components/restart-workflow-instance";
import { ProgramSourceRepository } from "src/components/program-source-repository";
import {ProgramSummary} from "src/components/sm-overview-dashboards/summary-view/program-summary-view";
import {ProgramDetailFailure} from "src/components/sm-overview-dashboards/workflow-detail-view/workflow-failure-detail-view";
import { WorkFlowList } from "./sm-overview-dashboards/workflow-list-view/workflow-list-view";
import {
    ProgramDetailRunning
} from "src/components/sm-overview-dashboards/workflow-detail-view/workflow-running-detail-view";
import {ProductSummary} from "src/components/sm-overview-dashboards/summary-view/product-summary-view";
import CreateWorkitem from "src/components/wim";
import { WebsiteViewLayout } from "./website-view/app-layout";

const queryClient = new QueryClient()

export class App extends React.Component {

    render() {
        return (
            <>
                <Authentication>
                    <QueryClientProvider client={queryClient}>
                    <div className="awsui">
                        <BrowserRouter>
                            {/* Use HashRouter instead of BrowserRouter in development */}
                            {/*<HashRouter>*/}
                            <Switch>
                                <Route exact path={AppRoutes.home} component={ServiceHomepage}/>
                                <Route exact path={AppRoutes.wimOutput(`:${AppRouteParams.wimOutput.workitemId}`)}
                                       component={WIMOutput}/>
                                <Route exact path="/ud/execution-list" component={DomainTracker}>
                                    <Redirect to={AppRoutes.executionList}/>
                                </Route>
                                <Route exact path={AppRoutes.executionList} component={DomainTracker}/>
                                <Route exact
                                       path={AppRoutes.executionDetail(`:${AppRouteParams.executionDetail.workflowId}`)}
                                       component={ExecutionDetailPage}/>
                                <Route exact
                                       path={AppRoutes.executionAttempts(`:${AppRouteParams.executionDetail.workflowId}`)}
                                       component={ExecutionAttemptsPage}/>
                                <Route exact
                                path={AppRoutes.executionSummary}
                                component={ExecutionSummary}/>
                                <Route exact
                                       path={AppRoutes.releaseNotes}
                                       component={ReleaseNotes}/>
                                <Route exact path={AppRoutes.virtualPipelines} component={VirtualPipeline}/>
                                <Route exact path={`${AppRoutes.virtualPipelines}/instance/:vpId`} component={VirtualPipelineInstance}/>
                                <Route exact path={`${AppRoutes.virtualPipelines}/visualization/:vpId`} component={VirtualPipelineVisualization}/>

                                <Route exact
                                       path={AppRoutes.executionSummaryRedirect}
                                       component={ExecutionSummaryRedirectPage}/>
                                <Route exact
                                       path={AppRoutes.startWorkflowInstance}
                                       component={StartWorkflowInstance}/>
                                <Route exact path = {AppRoutes.restartWorkflowInstance} component={RestartWorkflowInstance}/>
                                <Route path={AppRoutes.ProgramSourceConfigStore} component={ProgramSourceRepository}/>
                                <Route exact
                                       path={"/es-query-converter"}
                                       component={EsQueryConverter}/>
                                <Route exact path={AppRoutes.programSummary} component={ProgramSummary}>
                                    {({ location }) => (
                                        <Redirect
                                            to={{
                                                pathname: AppRoutes.productSummary,
                                                search: location.search
                                            }}
                                        />
                                    )}
                                </Route>
                                <Route exact path={AppRoutes.classificationTagSummary} component={ProgramSummary}/>
                                <Route exact path={AppRoutes.productSummary} component={ProductSummary} />
                                <Route exact path={AppRoutes.programSummaryDetailFailure} component={ProgramDetailFailure}/>
                                <Route exact path={AppRoutes.programSummaryDetailRunning} component={ProgramDetailRunning}/>
                                <Route exact path={AppRoutes.workflowList} component={WorkFlowList}/>
                                <Route exact path={AppRoutes.createWorkitem} component={CreateWorkitem}/>
                                <Route exact path={AppRoutes.websiteView} component={WebsiteViewLayout} />
                                <Route path="*" component={PageNotFound}/>
                            </Switch>
                            {/*</HashRouter>*/}
                        </BrowserRouter>
                    </div>
                    </QueryClientProvider>
                </Authentication>
                <div>
                    <ToastContainer className="custom-toast" position={toast.POSITION.TOP_CENTER}
                                    style={{width: "500px"}}/>
                </div>
            </>
        );
    }
}

export default App;
